import React from "react";
import { motion } from "framer-motion";
import "../components/LatestCollection.css";
import img1 from "../assets/kid1.webp";
import img2 from "../assets/kid2.webp";
import img3 from "../assets/kid3.webp";
import img4 from "../assets/kid4.webp";

const collections = [
  {
    id: 1,
    title: "Child Jacket",
    image:img1,
  },
  {
    id: 2,
    title: "Child Track-Suit",
    image: img2,
  },
  {
    id: 3,
    title: "Child Sweaters",
    image: img3,
  },
  {
    id: 4,
    title: "Child Sweat Top & Hoodies",
    image: img4,
  },
//   {
//     id: 5,
//     title: "Mens Shorts & Lower",
//     image:img5,
//   },
//   {
//     id: 6,
//     title: "Mens Jeans & Pant",
//     image:img6,
//   },
];

export default function ChildrenCollection() {
  return (
    <section className="latest-collection">
      <div className="collection-header">
        <h2>Children Product Showcase</h2>
      </div>

      <div className="collection-grid three-center">
        {collections.map((item, index) => (
          <motion.div
            key={item.id}
            className="collection-card"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.2, duration: 0.6 }}
            whileHover={{ scale: 1.05 }}
          >
            <img src={item.image} alt={item.title} />
            <h4>{item.title}</h4>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
